import { useState } from "react";
import { Menu, Button, TextInput, Select, UnstyledButton, Flex, Text, Box } from "@mantine/core";
import { IconUserPlus } from "@tabler/icons";
import { useAuth0 } from "@auth0/auth0-react";
import { inviteUser } from "../../../Api";
import { sidebarFooterTargetClass, sidebarFooterLabelClass } from "./utils";

const InviteMembersDropdown = ({
  sidebarExpanded,
}: {
  sidebarExpanded: boolean;
}) => {
  const auth0 = useAuth0();
  const [inviteName, setInviteName] = useState<string>("");
  const [inviteEmail, setInviteEmail] = useState<string>("");
  const [inviteRole, setInviteRole] = useState<string | null>("gtm");

  const submitInvite = () => {
    if (!inviteRole) {
      
      return;
    }
    const user = {
      name: inviteName,
      email: inviteEmail,
      role: inviteRole,
    };
    inviteUser(auth0, user)
      .then(() => {
        console.log("succees");
      })
      .catch((e) => console.log(e.error));
  };
  const roles = [
    { value: "admin", label: "Admin" },
    { value: "manager", label: "Manager" },
    { value: "gtm-manager", label: "GTM Manager" },
    { value: "gtm", label: "GTM" },
  ];

  return (
    <Menu width={300} shadow="md" position={"left-end"} withArrow withinPortal>
      <Menu.Target>
        <UnstyledButton className={sidebarFooterTargetClass(sidebarExpanded)}>
          <Flex align="center" w="100%">
            <Box className="sidebar-footer-icon-slot">
              <IconUserPlus color="#4B4BE8" size={20} stroke={2} />
            </Box>
            <Text
              ml="md"
              fz="14px"
              mb="1px"
              lineClamp={1}
              className={sidebarFooterLabelClass(sidebarExpanded)}
            >
              Invite
            </Text>
          </Flex>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown p={"md"}>
        <TextInput
          value={inviteName}
          onChange={(event: any) => setInviteName(event.currentTarget.value)}
          label="Name"
          placeholder="Name"
          size="xs"
        />
        <TextInput
          value={inviteEmail}
          onChange={(event: any) => setInviteEmail(event.currentTarget.value)}
          label="Email"
          placeholder="john@doe.com"
          size="xs"
          mt="xs"
        />
        <Select
          value={inviteRole}
          label="Role"
          onChange={setInviteRole}
          data={roles}
          mt={"md"}
        />
        <Menu.Item p={0} mt={"md"}>
          <Button
            className="profile-menu-invite-submit"
            onClick={submitInvite}
            bg={"#5C5CEA"}
            fullWidth
            fw={700}
            color={"#fff"}
          >
            Invite User
          </Button>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default InviteMembersDropdown;
